// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--tZOh4","inner":"footer-module--inner--2eYPj"};